import { Reveal } from "../components/Reveal";
import { Handshake, Buildings, Heartbeat } from "@phosphor-icons/react";

const PILLARS = [
  { Icon: Buildings, label: "Hospitales" },
  { Icon: Handshake, label: "Asociaciones de pacientes" },
  { Icon: Heartbeat, label: "Clínicas y consultas privadas" },
];

export default function Colaboraciones() {
  return (
    <section
      id="colaboraciones"
      data-testid="colaboraciones-section"
      className="py-24 md:py-32 bg-[#F6F1E7]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10 items-center">
        <Reveal className="lg:col-span-6">
          <p className="overline mb-6">
            <span className="text-[#D7C6A3]">11</span> &nbsp;/&nbsp; Colaboraciones
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-[#2D3732] leading-tight">
            Sumamos manos <br />
            con quienes cuidan.
          </h2>
          <p className="text-[#4A554E] mt-6 max-w-lg font-light leading-relaxed">
            Colaboramos con <strong className="font-normal text-[#2D3732]">hospitales,
            asociaciones de pacientes y clínicas</strong> que quieran dar visibilidad a
            VITAE entre sus pacientes. Si te representa una entidad y quieres compartirlo con
            los tuyos, escríbenos y estudiamos condiciones especiales, muestras y material.
          </p>
          <a
            href="#contacto"
            data-testid="colaboraciones-cta"
            className="inline-flex mt-8 items-center gap-2 bg-[#A3B18A] hover:bg-[#8A9A6F] text-white rounded-full pl-6 pr-5 py-3.5 text-sm tracking-wide transition-colors duration-300"
          >
            Contactar para colaborar
          </a>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-6">
          <div className="grid sm:grid-cols-3 gap-4">
            {PILLARS.map(({ Icon, label }) => (
              <div
                key={label}
                className="bg-white border border-[#E3E0D6] rounded-2xl px-5 py-8 text-center flex flex-col items-center gap-3 shadow-[0_6px_24px_-12px_rgba(45,55,50,0.15)]"
              >
                <Icon size={32} weight="light" className="text-[#8A9A6F]" />
                <p className="font-display text-lg text-[#2D3732] leading-tight">
                  {label}
                </p>
              </div>
            ))}
          </div>
          <p className="text-xs text-[#6B705C] mt-6 text-center italic font-light">
            Una parte de cada colaboración se destina a apoyar a pacientes con menos recursos.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
